const pageMeta = {
  home: {
    title:
      "EkritFly | Strategy, Marketing & Technology",

    description:
      "Helping businesses scale through strategy, marketing and technology."
  },

  about: {
    title:
      "About EkritFly",

    description:
      "Learn about EkritFly's approach to growth consulting, marketing and technology."
  },

  services: {
    title:
      "Services | EkritFly",

    description:
      "Consulting, SEO, performance marketing, websites and automation services."
  },

  industries: {
    title:
      "Industries | EkritFly",

    description:
      "Industry-specific growth strategies for healthcare, real estate, education and more."
  },

  caseStudies: {
    title:
      "Case Studies | EkritFly",

    description:
      "Growth strategies, challenges and outcomes from real-world business scenarios."
  },

  blog: {
    title:
      "Blog | EkritFly",

    description:
      "Insights on SEO, marketing, growth and business strategy."
  },

  audit: {
    title:
      "Free Growth Audit | EkritFly",

    description:
      "Request a free growth audit and discover opportunities to improve visibility and lead generation."
  },

  contact: {
    title:
      "Contact | EkritFly",

    description:
      "Get in touch with EkritFly to discuss growth opportunities."
  }
};

export default pageMeta;